import React, {useEffect, useMemo} from "react";
import {Card, CardBody, CardHeader, CardHeaderToolbar, ModalProgressBar,} from "../../../_metronic/_partials/controls";
import ProductsTable from "./ProductsTable";
import {useProductsUIContext} from "./ProductsUIContext";
import {shallowEqual, useSelector} from "react-redux";
import {useHistory, useLocation} from 'react-router-dom';


export default function ProductsListCmp() {

    const productContext = useProductsUIContext();
    const productProps = useMemo(() => {
        return {
            data: productContext.data,
            fetchData: productContext.fetchData,
        }
    }, [productContext]);

    let query = useQuery();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const history = useHistory();

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        productProps.fetchData(query.get("page") ? query.get("page") : 1);
    }, [query.get("page")]);


    function handlePageChange(page) {
        history.push(`${history.location.pathname}?page=${page}`)
    }

    return (
        <>
            {actionsLoading && <ModalProgressBar/>}
            <Card>
                <CardHeader title="لیست محصولات">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-warning ml-2"
                            onClick={() => {
                                productProps.fetchData(query.get("page"))
                            }}>
                            بارگزاری مجدد
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                    {productProps.data?.total &&
                    <ProductsTable
                        data={productProps.data}
                        handlePageChange={handlePageChange}
                        activePage={query.get("page") ? query.get("page") : 1}/>
                    }

                </CardBody>
            </Card>
        </>
    )
}